<div class="modal-header border-0 pb-0">
  <span class="fs-3 text-center fw-bold w-100 m-auto">
    Situação de vida{{getSelectedPlans()}}
  </span>
  <button type="button" class="btn-close" (click)="modalRef.hide()"></button>
</div>
<p class="modal-text">
  Listamos alguns objetivos tipicamente associados a essa(s) situação(ões) de vida.
  Escolha um ou mais para incluir.
</p>
<div class="modal-body">
  <div class="row">
    <ul *ngFor="let item of listGoal" class="col-6 col-md-4 col-lg-3 col-xxl-2">
      <li *ngIf="item.contem">
        <label class="card" [class.active]="item?.selected" for="goal-{{ item.value }}" role="button">
          <div class="card-body d-flex align-items-center justify-content-center py-2" [style.height.px]="70">
            <div class="col-auto">
              <icon-svg [svgName]="item.icon" class="me-2"></icon-svg>
            </div>
            <div class="col text-center">
              <span class="text-wrap">{{item.name}}</span>
              <input type="checkbox" class="d-none" name="situation" id="goal-{{ item.value }}"
                [(ngModel)]="item.selected" />
            </div>
          </div>
        </label>
      </li>
    </ul>
  </div>
</div>
<div class="d-flex justify-content-center mb-4">
  <button type="button" class="btn btn-outline-dark" data-dismiss="modal" (click)="modalRef.hide()">VOLTAR</button>
  <button type="button" class="btn btn-primary" (click)="onConfirm()">CONTINUAR</button>
</div>